/**
 * @deprecated This package has been renamed to "neon-new".
 * Please update your imports: import { instantPostgres } from 'neon-new/sdk'
 */

// Re-export everything from the lib module
export * from "./lib/index.js";
